module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', {
    staticClass: "Err404"
  }, [_c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "conteneurerreur"
  }, [_c('div', {
    staticClass: "contenuerreur"
  }, [_c('div', {
    staticClass: "f2"
  }, [_vm._v("Oops!")]), _c('div', {
    staticClass: "f4 mt2"
  }, [_vm._v("We could not find the page you are looking for, sorry!")]), _c('div', {
    staticClass: "mb5 mt4"
  }, [_c('router-link', {
    staticClass: "historybtn",
    attrs: {
      "to": {
        name: 'hello'
      }
    }
  }, [_vm._v("Back to main menu")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-091500e6","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Err404.vue
// module id = 1275
// module chunks = 1